import { api } from "@/integrations/clients/carAuction/carAuctionClient";
import {
  Transport,
  CreateTransportRequest,
  UpdateTransportRequest,
  GetTransportsResponse,
} from "@/types/transport";

export class TransportService {
  // Get all transports for a specific auction
  // TODO: TEMPORRAY SOLUTION FOR LISTINGSERVICE, WILL BE REMOVED WHEN FULLY INTEGRATED
  static async getTransportsByAuction(listingId: string): Promise<Transport[]> {
    // Simulate API delay
    await new Promise((resolve) => setTimeout(resolve, 300));

    // Mock response with sample transports for specific auction IDs
    const mockTransports: Transport[] = [];

    // Add seller_pickup transport for all auction IDs with different statuses
    if (listingId === "68813773703045dee1bf1ec1") {
      // Seller pickup - Not started
      mockTransports.push({
        id: 1,
        listingId: listingId,
        type: "seller_pickup",
        fromAddress: "Storgatan 123, 12345 Stockholm",
        toAddress: "Bilenia Lager, Hägersten, Stockholm",
        status: "not_started",
        comment: "Väntar på säljarens bekräftelse",
        createdAt: "2025-01-15T10:00:00.000Z",
        updatedAt: "2025-01-15T10:00:00.000Z",
      });
      // Buyer pickup - Planned
      mockTransports.push({
        id: 6,
        listingId: listingId,
        type: "buyer_pickup",
        fromAddress: "Bilenia Lager, Hägersten, Stockholm",
        toAddress: "Köparens adress, Göteborg",
        status: "planned",
        scheduledDate: "2025-01-25T14:00:00.000Z",
        comment: "Schemalagd för nästa vecka",
        createdAt: "2025-01-16T09:00:00.000Z",
        updatedAt: "2025-01-16T09:00:00.000Z",
      });
    } else if (listingId === "68813773703045dee1bf1ec2") {
      // Seller pickup - Planned
      mockTransports.push({
        id: 2,
        listingId: listingId,
        type: "seller_pickup",
        fromAddress: "Vasagatan 45, 11120 Stockholm",
        toAddress: "Bilenia Lager, Hägersten, Stockholm",
        status: "planned",
        scheduledDate: "2025-01-22T14:00:00.000Z",
        comment: "Schemalagd för nästa vecka, säljaren bekräftat",
        createdAt: "2025-01-16T09:00:00.000Z",
        updatedAt: "2025-01-16T09:00:00.000Z",
      });
      // Buyer delivery - In progress
      mockTransports.push({
        id: 7,
        listingId: listingId,
        type: "buyer_delivery",
        fromAddress: "Bilenia Lager, Hägersten, Stockholm",
        toAddress: "Köparens adress, Malmö",
        status: "in_progress",
        scheduledDate: "2025-01-21T09:00:00.000Z",
        comment: "Hemleverans pågår",
        createdAt: "2025-01-17T10:00:00.000Z",
        updatedAt: "2025-01-21T09:15:00.000Z",
      });
    } else if (listingId === "68813773703045dee1bf1ec3") {
      // Seller pickup - In progress
      mockTransports.push({
        id: 3,
        listingId: listingId,
        type: "seller_pickup",
        fromAddress: "Drottninggatan 78, 11360 Stockholm",
        toAddress: "Bilenia Lager, Hägersten, Stockholm",
        status: "in_progress",
        scheduledDate: "2025-01-20T10:00:00.000Z",
        comment: "Transport pågår, förväntad ankomst 12:00",
        createdAt: "2025-01-17T08:00:00.000Z",
        updatedAt: "2025-01-20T10:30:00.000Z",
      });
      // Buyer pickup - Completed
      mockTransports.push({
        id: 8,
        listingId: listingId,
        type: "buyer_pickup",
        fromAddress: "Bilenia Lager, Hägersten, Stockholm",
        toAddress: "Bilenia Lager, Hägersten, Stockholm",
        status: "completed",
        scheduledDate: "2025-01-19T16:00:00.000Z",
        comment: "Upphämtning slutförd",
        createdAt: "2025-01-18T14:00:00.000Z",
        updatedAt: "2025-01-19T16:30:00.000Z",
      });
    } else if (listingId === "68813773703045dee1bf1ec4") {
      // Seller pickup - Completed
      mockTransports.push({
        id: 4,
        listingId: listingId,
        type: "seller_pickup",
        fromAddress: "Birger Jarlsgatan 12, 11434 Stockholm",
        toAddress: "Bilenia Lager, Hägersten, Stockholm",
        status: "completed",
        scheduledDate: "2025-01-18T15:00:00.000Z",
        comment: "Upphämtning slutförd, fordon mottaget i lager",
        createdAt: "2025-01-15T14:00:00.000Z",
        updatedAt: "2025-01-18T15:45:00.000Z",
      });
      // Buyer delivery - Completed
      mockTransports.push({
        id: 9,
        listingId: listingId,
        type: "buyer_delivery",
        fromAddress: "Bilenia Lager, Hägersten, Stockholm",
        toAddress: "Köparens adress, Uppsala",
        status: "completed",
        scheduledDate: "2025-01-20T11:00:00.000Z",
        comment: "Hemleverans slutförd",
        createdAt: "2025-01-19T08:00:00.000Z",
        updatedAt: "2025-01-20T11:45:00.000Z",
      });
    } else if (listingId === "68813773703045dee1bf1ec5") {
      // Seller pickup - Not started
      mockTransports.push({
        id: 5,
        listingId: listingId,
        type: "seller_pickup",
        fromAddress: "Kungsgatan 34, 11135 Stockholm",
        toAddress: "Bilenia Lager, Hägersten, Stockholm",
        status: "not_started",
        comment: "Nyligen skapad annons, väntar på säljarens svar",
        createdAt: "2025-01-19T16:00:00.000Z",
        updatedAt: "2025-01-19T16:00:00.000Z",
      });
      // No buyer transport yet - this auction is not sold
    } else if (listingId === "68813773703045dee1bf1ec7") {
      // Seller pickup - Not started
      mockTransports.push({
        id: 7,
        listingId: listingId,
        type: "seller_pickup",
        fromAddress: "Drottninggatan 45, 11121 Stockholm",
        toAddress: "Bilenia Lager, Hägersten, Stockholm",
        status: "not_started",
        comment: "Transport skapas automatiskt när annonsen skapas",
        createdAt: "2025-01-20T10:00:00.000Z",
        updatedAt: "2025-01-20T10:00:00.000Z",
      });

      mockTransports.push({
        id: 100,
        listingId: listingId,
        type: "buyer_delivery",
        fromAddress: "Bilenia Lager, Hägersten, Stockholm",
        toAddress: "Vasagatan 10, 11120 Stockholm",
        status: "completed",
        scheduledDate: "2025-01-19T16:00:00.000Z",
        comment: "Hemleverans slutförd",
        createdAt: "2025-01-17T14:00:00.000Z",
        updatedAt: "2025-01-19T16:45:00.000Z",
      });
    } else if (listingId === "my_listing_003") {
      // Seller pickup - Completed
      mockTransports.push({
        id: 101,
        listingId: listingId,
        type: "seller_pickup",
        fromAddress: "Säljarens adress, Göteborg",
        toAddress: "Bilenia Lager, Hägersten, Stockholm",
        status: "completed",
        scheduledDate: "2025-01-12T10:00:00.000Z",
        comment: "Hämtning slutförd",
        createdAt: "2025-01-10T08:00:00.000Z",
        updatedAt: "2025-01-12T10:30:00.000Z",
      });

      // Buyer delivery - Completed
      mockTransports.push({
        id: 102,
        listingId: listingId,
        type: "buyer_delivery",
        fromAddress: "Bilenia Lager, Hägersten, Stockholm",
        toAddress: "Köparens adress, Göteborg",
        status: "completed",
        scheduledDate: "2025-01-19T14:00:00.000Z",
        comment: "Hemleverans slutförd",
        createdAt: "2025-01-15T10:00:00.000Z",
        updatedAt: "2025-01-19T14:30:00.000Z",
      });
    }

    return mockTransports;
    // return response.data.transports;
  }

  // Get all transports with pagination
  // TODO: TEMPORRAY SOLUTION FOR LISTINGSERVICE, WILL BE REMOVED WHEN FULLY INTEGRATED
  static async getAllTransports(
    page: number = 1,
    limit: number = 10,
  ): Promise<GetTransportsResponse> {
    // Simulate API delay
    await new Promise((resolve) => setTimeout(resolve, 500));

    // Mock response with sample transports for all auction IDs
    const mockTransports: Transport[] = [
      // Seller pickups for all auction IDs
      {
        id: 1,
        listingId: "68813773703045dee1bf1ec1",
        type: "seller_pickup",
        fromAddress: "Storgatan 123, 12345 Stockholm",
        toAddress: "Bilenia Lager, Hägersten, Stockholm",
        status: "not_started",
        comment: "Väntar på säljarens bekräftelse",
        createdAt: "2025-01-15T10:00:00.000Z",
        updatedAt: "2025-01-15T10:00:00.000Z",
      },
      {
        id: 2,
        listingId: "68813773703045dee1bf1ec2",
        type: "seller_pickup",
        fromAddress: "Vasagatan 45, 11120 Stockholm",
        toAddress: "Bilenia Lager, Hägersten, Stockholm",
        status: "planned",
        scheduledDate: "2025-01-22T14:00:00.000Z",
        comment: "Schemalagd för nästa vecka, säljaren bekräftat",
        createdAt: "2025-01-16T09:00:00.000Z",
        updatedAt: "2025-01-16T09:00:00.000Z",
      },
      {
        id: 3,
        listingId: "68813773703045dee1bf1ec3",
        type: "seller_pickup",
        fromAddress: "Drottninggatan 78, 11360 Stockholm",
        toAddress: "Bilenia Lager, Hägersten, Stockholm",
        status: "in_progress",
        scheduledDate: "2025-01-20T10:00:00.000Z",
        comment: "Transport pågår, förväntad ankomst 12:00",
        createdAt: "2025-01-17T08:00:00.000Z",
        updatedAt: "2025-01-20T10:30:00.000Z",
      },
      {
        id: 4,
        listingId: "68813773703045dee1bf1ec4",
        type: "seller_pickup",
        fromAddress: "Birger Jarlsgatan 12, 11434 Stockholm",
        toAddress: "Bilenia Lager, Hägersten, Stockholm",
        status: "completed",
        scheduledDate: "2025-01-18T15:00:00.000Z",
        comment: "Upphämtning slutförd, fordon mottaget i lager",
        createdAt: "2025-01-15T14:00:00.000Z",
        updatedAt: "2025-01-18T15:45:00.000Z",
      },
      {
        id: 5,
        listingId: "68813773703045dee1bf1ec5",
        type: "seller_pickup",
        fromAddress: "Kungsgatan 34, 11135 Stockholm",
        toAddress: "Bilenia Lager, Hägersten, Stockholm",
        status: "not_started",
        comment: "Nyligen skapad annons, väntar på säljarens svar",
        createdAt: "2025-01-19T16:00:00.000Z",
        updatedAt: "2025-01-19T16:00:00.000Z",
      },
      // Some buyer transports for sold vehicles
      {
        id: 6,
        listingId: "68813773703045dee1bf1ec1",
        type: "buyer_pickup",
        fromAddress: "Bilenia Lager, Hägersten, Stockholm",
        toAddress: "Köparens adress, Göteborg",
        status: "planned",
        scheduledDate: "2025-01-25T14:00:00.000Z",
        comment: "Schemalagd för nästa vecka",
        createdAt: "2025-01-16T09:00:00.000Z",
        updatedAt: "2025-01-16T09:00:00.000Z",
      },
      {
        id: 7,
        listingId: "68813773703045dee1bf1ec2",
        type: "buyer_delivery",
        fromAddress: "Bilenia Lager, Hägersten, Stockholm",
        toAddress: "Köparens adress, Malmö",
        status: "in_progress",
        scheduledDate: "2025-01-21T09:00:00.000Z",
        comment: "Hemleverans pågår",
        createdAt: "2025-01-17T10:00:00.000Z",
        updatedAt: "2025-01-21T09:15:00.000Z",
      },
      {
        id: 8,
        listingId: "68813773703045dee1bf1ec3",
        type: "buyer_pickup",
        fromAddress: "Bilenia Lager, Hägersten, Stockholm",
        toAddress: "Bilenia Lager, Hägersten, Stockholm",
        status: "completed",
        scheduledDate: "2025-01-20T14:00:00.000Z",
        comment: "Fordonet upphämtat av köparen",
        createdAt: "2025-01-18T11:00:00.000Z",
        updatedAt: "2025-01-20T14:30:00.000Z",
      },
      {
        id: 9,
        listingId: "68813773703045dee1bf1ec4",
        type: "buyer_delivery",
        fromAddress: "Bilenia Lager, Hägersten, Stockholm",
        toAddress: "Vasagatan 10, 11120 Stockholm",
        status: "completed",
        scheduledDate: "2025-01-19T16:00:00.000Z",
        comment: "Hemleverans slutförd",
        createdAt: "2025-01-17T14:00:00.000Z",
        updatedAt: "2025-01-19T16:45:00.000Z",
      },
    ];

    return {
      transports: mockTransports,
      total: mockTransports.length,
      page,
      limit,
    };
    // return response.data;
  }
  // Create a new transport (for buyer delivery/pickup)
  static async createTransport(
    data: CreateTransportRequest,
    isAdmin: boolean = false,
  ): Promise<Transport> {
    // Only handle buyer transports here
    // TODO: Also manage seller_pickup?
    if (data.type !== "buyer_pickup" && data.type !== "buyer_delivery") {
      throw new Error(
        "createTransport only supports buyer_pickup and buyer_delivery",
      );
    }

    // Map to backend format
    const transportType =
      data.type === "buyer_pickup" ? "BUYER_PICKUP" : "BUYER_DELIVERY";

    const requestBody: any = {
      transportType,
      deliveryAt: data.scheduledDate,
      deliveryInstructions: data.comment,
    };

    // For buyer_delivery, include address
    if (data.type === "buyer_delivery" && data.toAddress) {
      requestBody.address = data.toAddress;
    }

    try {
      // Use admin endpoint if admin, otherwise use buyer endpoint
      const endpoint = isAdmin
        ? `/admin/listings/${data.listingId}/buyer-delivery`
        : `/listings/${data.listingId}/delivery`;

      const response = await api.post<{
        success: boolean;
        data: {
          id: string;
          listingId: string;
          transportType: string;
          status: string;
          deliveryAt: string;
          deliveryInstructions?: string;
          address?: string | null;
          createdAt: string;
          updatedAt: string;
        };
      }>(endpoint, requestBody);

      if (!response.success || !response.data) {
        throw new Error("Invalid response from server");
      }

      return this.mapDeliveryToTransport(response.data);
    } catch (error: any) {
      throw error;
    }
  }

  // Update an existing transport
  static async updateTransport(
    data: UpdateTransportRequest,
    isAdmin: boolean = false,
  ): Promise<Transport> {
    if (!data.listingId) {
      throw new Error("listingId is required for updating transport");
    }

    // Check if this is a buyer transport (buyer_pickup or buyer_delivery)
    const isBuyerTransport =
      data.type === "buyer_pickup" || data.type === "buyer_delivery";

    if (isBuyerTransport) {
      // Use buyer delivery endpoint
      const transportType =
        data.type === "buyer_pickup" ? "BUYER_PICKUP" : "BUYER_DELIVERY";

      const requestBody: any = {
        transportType,
        status: data.status,
        deliveryAt: data.scheduledDate,
        deliveryInstructions: data.comment,
      };

      // For buyer_delivery, include address
      if (data.type === "buyer_delivery" && data.address) {
        requestBody.address = data.address;
      } else if (data.type === "buyer_delivery" && data.toAddress) {
        requestBody.address = data.toAddress;
      }

      try {
        // Use admin endpoint if admin, otherwise use buyer endpoint
        const endpoint = isAdmin
          ? `/admin/listings/${data.listingId}/buyer-delivery`
          : `/listings/${data.listingId}/delivery`;

        const response = await api.put<{
          success: boolean;
          data: {
            id: string;
            listingId: string;
            transportType: string;
            status: string;
            deliveryAt: string;
            deliveryInstructions?: string;
            address?: string | null;
            createdAt: string;
            updatedAt: string;
          };
        }>(endpoint, requestBody);

        if (!response.success || !response.data) {
          throw new Error("Invalid response from server");
        }

        return this.mapDeliveryToTransport(response.data);
      } catch (error: any) {
        throw error;
      }
    } else {
      // Use admin endpoint for seller transports
      if (!data.transportId) {
        throw new Error(
          "transportId is required for updating seller transport",
        );
      }

      // Map frontend status to backend enum
      const statusMap: Record<string, string> = {
        not_started: "NOT_STARTED",
        planned: "PLANNED",
        in_progress: "IN_PROGRESS",
        completed: "COMPLETED",
      };

      // Map frontend transport type to backend enum
      const transportTypeMap: Record<string, string> = {
        seller_pickup: "SELLER_PICKUP",
        buyer_pickup: "BUYER_PICKUP",
        buyer_delivery: "BUYER_DELIVERY",
      };

      // Prepare request body
      const requestBody: any = {
        transportId: data.transportId,
      };

      if (data.type !== undefined) {
        requestBody.transportType = transportTypeMap[data.type];
      }
      if (data.status !== undefined) {
        requestBody.status = statusMap[data.status];
      }
      if (data.scheduledDate !== undefined) {
        requestBody.deliveryAt = data.scheduledDate;
      }
      if (data.comment !== undefined) {
        requestBody.deliveryInstructions = data.comment;
      }
      // Send address field directly (denormalized, free text)
      if (data.address !== undefined) {
        requestBody.address = data.address;
      }

      try {
        const response = await api.patch<{
          success: boolean;
          data: {
            id: string;
            listingId: string;
            transportType: string;
            status: string;
            deliveryAt: string;
            deliveryInstructions?: string;
            address?: string | null;
            createdAt: string;
            updatedAt: string;
          };
        }>(`/admin/listings/${data.listingId}/transports`, requestBody);

        if (!response.success || !response.data) {
          throw new Error("Invalid response from server");
        }

        return this.mapDeliveryToTransport(response.data);
      } catch (error: any) {
        throw error;
      }
    }
  }

  // Helper method to map delivery response to Transport
  private static mapDeliveryToTransport(delivery: {
    id: string;
    listingId: string;
    transportType: string;
    status: string;
    deliveryAt: string;
    deliveryInstructions?: string;
    address?: string | null;
    createdAt: string;
    updatedAt: string;
  }): Transport {
    // Map backend response to frontend Transport format
    const transportTypeMapReverse: Record<
      string,
      "seller_pickup" | "buyer_pickup" | "buyer_delivery"
    > = {
      SELLER_PICKUP: "seller_pickup",
      BUYER_PICKUP: "buyer_pickup",
      BUYER_DELIVERY: "buyer_delivery",
    };

    const statusMapReverse: Record<
      string,
      "not_started" | "planned" | "in_progress" | "completed"
    > = {
      NOT_STARTED: "not_started",
      PLANNED: "planned",
      IN_PROGRESS: "in_progress",
      COMPLETED: "completed",
    };

    // Read address directly from denormalized address field
    const address = delivery.address || "";

    // Determine fromAddress and toAddress based on transportType
    const transportType =
      transportTypeMapReverse[delivery.transportType] || "seller_pickup";
    let fromAddress = "";
    let toAddress = "";

    if (transportType === "seller_pickup") {
      fromAddress = address;
      toAddress = "Bilenia Lager, Hägerstensvägen 123, 12345 Stockholm";
    } else if (transportType === "buyer_pickup") {
      // For buyer pickup, use address if available (warehouse address stored)
      fromAddress =
        address || "Bilenia Lager, Hägerstensvägen 123, 12345 Stockholm";
      toAddress =
        address || "Bilenia Lager, Hägerstensvägen 123, 12345 Stockholm";
    } else if (transportType === "buyer_delivery") {
      fromAddress = "Bilenia Lager, Hägerstensvägen 123, 12345 Stockholm";
      toAddress = address;
    }

    return {
      id: parseInt(delivery.id) || (delivery.id as any), // Keep compatibility with number type
      listingId: delivery.listingId,
      type: transportType,
      fromAddress,
      toAddress,
      status: statusMapReverse[delivery.status] || "not_started",
      scheduledDate: delivery.deliveryAt,
      comment: delivery.deliveryInstructions,
      createdAt: delivery.createdAt,
      updatedAt: delivery.updatedAt,
    };
  }

  // Delete a transport
  static async deleteTransport(
    id: number,
  ): Promise<{ success: boolean; message: string }> {
    // TODO: Replace with actual API call when backend is ready
    // const response = await api.delete(`/transports/${id}`);

    // Simulate API delay
    await new Promise((resolve) => setTimeout(resolve, 400));

    // Mock response
    return {
      success: true,
      message: "Transport borttagen framgångsrikt",
    };
    // return response.data;
  }
}
